export default state => ({
  ...state,
  persistentErrors: []
});
